import { Board } from '~/components/Shared/Layout/Board/Board';
import { Button, Pagination, Spinner } from '~/ui';
import { TableAmountPage } from '~/ui/TableAmountPage/TableAmountPage';
import styles from './RecordsBoard.module.scss';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { TableSelect } from '~/ui/TableSelect/TableSelect';
import { DatePicker } from 'antd';
import Arrow from '~/assets/svg/newSvg/select-arrow.svg?react';
import SlotsTable from '~/components/SlotsBoard/SlotsTable/SlotsTable';
import { useTranslation } from 'react-i18next';
import { useToastError } from '~/utils/useToastError';

const defaultDate = dayjs().format('YYYY-MM-DD');
interface SelectedPage {
  selected: number;
}

const RecordsBoard = () => {
  const { t } = useTranslation();
  const [date, setDate] = useState<Dayjs | null>(dayjs(defaultDate));
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(5);
  const [selectedSlots, setSelectedSlots] = useState<number[]>([]);
  const [sort, setSort] = useState({
    field: '',
    direction: '',
  });
  const toastError = useToastError();
  const params = {
    date: date?.format('YYYY-MM-DD'),
    page,
    perPage,
  };

  const { data, isLoading, refetch } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get(
        'admin/entertainment-date-slots-all',
        { params }
      );
      return data;
    },
    queryKey: ['records', params],
  });

  const handleSelect = (id: number) => {
    if (selectedSlots.includes(id)) {
      const filteredUsers = selectedSlots.filter(
        selectedId => selectedId !== id
      );
      setSelectedSlots(filteredUsers);
    } else {
      setSelectedSlots([...selectedSlots, id]);
    }
  };

  const handleToggleAll = () => {
    if (selectedSlots.length === data?.data.length) {
      setSelectedSlots([]);
    } else {
      const userIdArray = data?.data.data.map((user: any) => user.id);
      setSelectedSlots(userIdArray);
    }
  };

  const handleBlockSlots = async () => {
    try {
      await instance.delete('admin/entertainment-date-slots', {
        data: {
          date_slot_ids: selectedSlots,
        },
      });
      setSelectedSlots([]);
      refetch();
    } catch (error) {
      toastError(error);
    }
  };

  return (
    <Board>
      <div className={styles.recordsBoardWrapper}>
        <div className={styles.recordsTableOptions}>
          <TableSelect perPage={perPage} setPerPage={setPerPage} />
          <div className={styles.tableHeadRightWrapper}>
            <div className={styles.deleteButtonContainer}>
              {!!selectedSlots.length && (
                <Button
                  text={t('block_slots')}
                  color="red"
                  onClick={handleBlockSlots}
                  className={styles.deleteButton}
                />
              )}
            </div>
            <DatePicker
              value={date}
              inputReadOnly
              format="DD.MM.YYYY"
              onChange={date => setDate(date)}
              className={styles.datePicker}
              suffixIcon={<Arrow />}
            />
          </div>
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <SlotsTable
            places={data?.data}
            refetch={refetch}
            sort={sort}
            setSort={setSort}
            selectedItems={selectedSlots}
            handleToggle={handleSelect}
            handleToggleAll={handleToggleAll}
            withName={true}
          />
        )}

        <div className={styles.foodTablePagination}>
          <TableAmountPage
            firstRow={data?.from}
            lastRow={data?.to}
            total={data?.total}
          />
          <Pagination
            pageCount={data?.last_page}
            onPageChange={(selectedPage: SelectedPage) => {
              setPage(selectedPage.selected + 1);
            }}
          />
        </div>
      </div>
    </Board>
  );
};

export default RecordsBoard;
